import React from 'react';
import { Carousel as BootstrapCarousel } from 'react-bootstrap';

const Carousel = ({ 
    items = [], 
    activeIndex,
    onSelect,
    indicators = true,
    controls = true,
    fade = false,
    interval = 5000,
    pause = 'hover',
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapCarousel 
            activeIndex={activeIndex}
            onSelect={onSelect}
            indicators={indicators}
            controls={controls}
            fade={fade}
            interval={interval}
            pause={pause}
            className={className} 
            style={style}
            {...props}
        >
            {items.map((item, index) => (
                <BootstrapCarousel.Item key={index}>
                    {item.image && (
                        <img
                            className="d-block w-100"
                            src={item.image}
                            alt={item.alt || `Slide ${index + 1}`}
                        />
                    )}
                    {(item.caption || item.title || item.description) && (
                        <BootstrapCarousel.Caption>
                            {item.title && <h3>{item.title}</h3>}
                            {(item.description || item.caption) && <p>{item.description || item.caption}</p>}
                        </BootstrapCarousel.Caption>
                    )}
                </BootstrapCarousel.Item>
            ))}
        </BootstrapCarousel>
    );
};

export default Carousel;

